

















import { defineComponent } from '@nuxtjs/composition-api';
import { BaseButton, BaseHeading, BaseImage } from '@shared/ui';

export default defineComponent({
  name: 'ErrorLayout',
  components: {
    BaseButton,
    BaseImage,
    BaseHeading,
  },
  props: {
    error: {
      type: Object,
      default: () => ({
        statusCode: 500,
        message: 'An unexpected error has occurred.',
      }),
    },
  },
});
